import { useMutation } from '@apollo/client';
import { createWishListStudio } from '../../graphql/mutations/wishlistMutations';

export const useCreateWishListStudio = () => {
  const [createWishlistMutation, { loading, error }] = useMutation(createWishListStudio, {
    refetchQueries: ['WishListsByUserID'],
    awaitRefetchQueries: true
  });

  const sanitizeInput = (input = {}) => {
    const cleaned = { ...input };
    Object.keys(cleaned).forEach((key) => {
      if (cleaned[key] === undefined) {
        delete cleaned[key];
      }
    });
    return cleaned;
  };

  const handleWishlistStudioCreation = async (wishlistData) => {
    try {
      if (!wishlistData?.wishListID || !wishlistData?.studioID) {
        throw new Error('wishListID and studioID are required');
      }

      const input = sanitizeInput({
        wishListID: wishlistData.wishListID,
        studioID: wishlistData.studioID
      });

      const variables = sanitizeInput({
        input,
        condition: wishlistData?.condition
      });

      const { data: wishlistResponse } = await createWishlistMutation({
        variables
      });

      return wishlistResponse?.createWishListStudio;
    } catch (error) {
      console.error('Error creating wishlist studio:', error);
      throw error;
    }
  };

  return {
    handleWishlistStudioCreation,
    loading,
    error
  };
};